import {all, fork} from 'redux-saga/effects'
import * as countrySagas from './countries';
import * as citiesSagas from './cities';
import * as userSagas from './user';
import * as settings from './settings';
import * as cryodex from './cryodex';
import * as cryodexLinks from './cryodexLinks';
import * as cryodexGroups from './cryodexGroups';
import * as infodexGroups from './infodexGroups';
import * as infodex from './infodex';
import * as linkedInfodex from './linkedInfodex';
import * as linkedCryodex from './linkedCryodex';
import * as locationSaga from './locations';
import * as mailbox from './mailbox';
import * as favouredInfodex from './favouredInfodex';
import * as friends from './friends';
import * as allFriendsSaga from './allFriends';
import * as gFriends from './gFriends';



export default function* rootSaga() {
  yield all([
            ...Object.values(citiesSagas),
            ...Object.values(countrySagas),
            ...Object.values(userSagas),
			...Object.values(friends),
			...Object.values(cryodex),
			...Object.values(settings),
			...Object.values(cryodexLinks),
            ...Object.values(infodex),
            ...Object.values(cryodexGroups),
            ...Object.values(infodexGroups),
            ...Object.values(locationSaga),
            ...Object.values(linkedCryodex),
            ...Object.values(linkedInfodex),
            ...Object.values(mailbox),            
            ...Object.values(favouredInfodex),
			...Object.values(allFriendsSaga),
			...Object.values(gFriends),
			
            ].map(fork));
}